// Use local calendar dates: converting to UTC can move an evening table to another day.
export function calendarDateKey(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function monthStart(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function monthDays(month) {
    const first = monthStart(month);
    const offset = (first.getDay() + 6) % 7;
    const daysInMonth = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
    const cellCount = Math.ceil((offset + daysInMonth) / 7) * 7;
    return Array.from({ length: cellCount }, (_, index) => {
        const day = index - offset + 1;
        return day < 1 || day > daysInMonth ? null : new Date(first.getFullYear(), first.getMonth(), day);
    });
}
